import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { Controller, useForm } from "react-hook-form";
import PlacesAutoComplete from "./PlacesAutoComplete";
import { ATHENA_VIR_PREPARE_THERMEON } from "src/types/actions";
import * as virActions from "src/actions/virActions";
import useStyles from "src/layouts/DigitalVIRLayout/useStyles";
import { useIsMount } from "src/hooks/useIsMount";
import * as appActions from "../../actions/appActions";
import { RoundedButton } from "@packages/ui";
import { athenaURL } from "../../env";
import {
  TextField,
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  FormHelperText,
  CircularProgress,
} from "@material-ui/core";
import getBrandFromUrl from "src/utils/getBrandFromUrl";
import VirPhoneInput from "src/components/VirPhoneInput/VirPhoneInput";
import DiveButton from "src/components/DiveButton/DiveButton";
import brandColors from "@packages/ui/theme/colors";


const DigitalVIROtherDriverDetails = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const autoCompleteRef = useRef(null);
  const isMount = useIsMount();
  const brand = getBrandFromUrl().toLowerCase();
  const athenaSource = useSelector((state) => state.vir.athenaSource.source);

  const selectedVirid = useSelector((state) => state.vir?.athenaSelectedId?.selectedId);
  const resubmitFlag = useSelector((state) => state.vir?.athenaVirResubmit?.flag);
  const athenaVirDetailPatch = useSelector((state) => state.vir.athenaVirDetailPatch?.data);
  const athenaVirDetailError = useSelector((state) => state.vir.athenaVirDetailPatch?.error);
  const athenaVirDetailLoading = useSelector((state) => state.vir.athenaVirDetailPatch?.loading);
  const athenaVirDetail = useSelector((state) => state.vir.athenaVirDetail?.data);
  const athenaRole = useSelector((state) => state.vir?.athenaRole?.role);
  const [loading, setLoading] = useState(false);

  const disableEdit = resubmitFlag && athenaRole !== "staff";
  const previousData = resubmitFlag
    ? athenaVirDetail?.OtherDriverDetails
    : athenaVirDetailPatch?.OtherDriverDetails;

  const [driverLicence, setDriverLicence] = useState(
    previousData?.DriverLicenceUploaded || false
  );
  const [incidentAddress, setIncidentAddress] = useState(previousData?.Address || "");
  useEffect(() => {
    if (!isMount) {
      if (!athenaVirDetailLoading && loading) {
        setLoading(false);
        if (athenaVirDetailError) {
          dispatch(
            appActions.createToast({
              type: "error",
              message: "Failed to update",
            })
          );
        } else {
          dispatch(
            appActions.createToast({
              type: "success",
              message: "Vehicle Incident Report is updated",
            })
          );
          dispatch(
            virActions.detailVir({
              virId: selectedVirid,
            })
          );
          navigate(`/vehicleincidents/thirdpartydetails?brand=${brand}`);
        }
      }
    }
  }, [athenaVirDetailLoading]);

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    trigger,
    formState: { errors, isDirty },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      customerPresent: previousData?.CustomerPresent || "no",
      firstName: previousData?.FirstName ? previousData?.FirstName : "",
      lastName: previousData?.LastName ? previousData?.LastName : "",
      drivingLicenceNumber: previousData?.DrivingLicenceNumber
        ? previousData?.DrivingLicenceNumber
        : "",
      address: previousData?.Address ? previousData?.Address : "",
      drivingLicenceExpiryDate: previousData?.DrivingLicenceExpiryDate
        ? previousData?.DrivingLicenceExpiryDate
        : "",
      cellTelephoneNumber: previousData?.CellTelephoneNumber
        ? previousData?.CellTelephoneNumber
        : "",
      email: previousData?.Email ? previousData?.Email : "",
      relationship: previousData?.Relationship ? previousData?.Relationship : "",
      otherRelationship: previousData?.OtherRelationship ? previousData?.OtherRelationship : "",
    },
  });
  // Get form values from watch
  const formFirstName = watch("firstName");
  const formLastName = watch("lastName");
  const formPhone = watch("cellTelephoneNumber");
  const formEmail = watch("email");

  const handleTextFieldChange = (event) => {
    const { name, value } = event.target;
    setValue(name, value);
  };

  const onSubmit = (data) => {
    setLoading(true);

    const virPayloadTHERMEON = {
      FirstName: data.firstName,
      LastName: data.lastName,
      DrivingLicenceNumber: data.drivingLicenceNumber,
      DrivingLicenceExpiryDate: data.drivingLicenceExpiryDate,
      CellTelephoneNumber: data.cellTelephoneNumber,
      Email: data.email,
      Address: incidentAddress || data.address,
      CustomerPresent: data.customerPresent,
      virId: selectedVirid,
    };

    if (data.customerPresent == "no") {
      virPayloadTHERMEON["CustomerPresent"] = "N";
    } else {
      virPayloadTHERMEON["CustomerPresent"] = "Y";
    }

    const params = {
      virId: selectedVirid,
      virStatus: resubmitFlag ? "SubmissionPage" : "OtherDriverDetails",
      data: {
        OtherDriverDetails: {
          FirstName: data.firstName,
          LastName: data.lastName,
          DrivingLicenceNumber: data.drivingLicenceNumber,
          DrivingLicenceExpiryDate: data.drivingLicenceExpiryDate,
          CellTelephoneNumber: data.cellTelephoneNumber,
          Email: data.email,
          Address: incidentAddress || data.address,
          CustomerPresent: data.customerPresent,
          Relationship: data.relationship,
          OtherRelationship: data.otherRelationship,
          DriverLicenceUploaded: driverLicence,
        },
      },
    };
    if (athenaSource === "sms" && isDirty) {
      params.data.CustomerEditBySms = true;
    }

    dispatch({ type: ATHENA_VIR_PREPARE_THERMEON, payload: virPayloadTHERMEON });
    dispatch(virActions.detailPatchVir(params));
  };

  const handleAddressChange = (address) => {
    setIncidentAddress(address); // Update the address in the parent
  };

  const handlePhoneChange = (value, name) => {
    setValue(name, value);
  };

  const handleDiveVerificationComplete = (success) => {
    if (success) {
      setDriverLicence(true);
      dispatch(
        appActions.createToast({
          type: "success",
          message: "Driver license verification completed successfully",
        })
      );
    }
  };

  return (
    <>
      <Box>
        <h2 className={classes.heading}>
          Please provide details of the person driving your rental vehicle at the time of the
          incident.
        </h2>
        <br></br>
      </Box>
      <hr className={classes.breakLine} style={{ borderColor: brandColors[brand] }} />

      <Box
        sx={{
          p: 4,
          textAlign: "left",
          fontFamily: "Ride",
          color: "#333",
          maxWidth: "500px",
          margin: "0 auto",
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Controller
                  control={control}
                  rules={{
                    required: "First Name is required",
                  }}
                  name="firstName"
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      inputProps={{
                        autoComplete: "new-password",
                      }}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                      multiline
                      maxRows={1}
                      id="firstName"
                      name="firstName"
                      label="First Name"
                      placeholder="Enter First Name"
                      value={value}
                      error={errors.firstName ? true : false}
                      onChange={handleTextFieldChange}
                      helperText={errors.firstName?.message}
                      disabled={
                        disableEdit &&
                        previousData?.FirstName &&
                        previousData?.FirstName !== undefined &&
                        previousData?.FirstName !== ""
                      }
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <Controller
                  control={control}
                  rules={{
                    required: "Last Name is required",
                  }}
                  name="lastName"
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      inputProps={{
                        autoComplete: "new-password",
                      }}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                      multiline
                      maxRows={1}
                      id="lastName"
                      name="lastName"
                      label="Last Name"
                      placeholder="Enter Last Name"
                      value={value}
                      error={errors.lastName ? true : false}
                      onChange={handleTextFieldChange}
                      helperText={errors.lastName?.message}
                      disabled={
                        disableEdit &&
                        previousData?.LastName &&
                        previousData?.LastName !== undefined &&
                        previousData?.LastName !== ""
                      }
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <DiveButton
                disabled={driverLicence}
                firstName={formFirstName || ""}
                lastName={formLastName || ""}
                phone={formPhone || ""}
                email={formEmail || ""}
                virId={selectedVirid}
                brand={brand}
                onVerificationComplete={handleDiveVerificationComplete}
                endpointName={"otherDriver"}
                onClickValidate={async () => {
                  return await trigger(["firstName", "lastName"]);
                }}
                title={
                  driverLicence 
                    ? "Other driver's license is uploaded"
                    : "Upload Other driver's license"
                }
              />
            </Grid>
            <Grid container>
              <Grid item xs={12}>
                <TextField
                  label="Driver Licence #"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  {...register("drivingLicenceNumber")}
                  disabled={
                    disableEdit &&
                    previousData?.DrivingLicenceNumber &&
                    previousData?.DrivingLicenceNumber !== undefined &&
                    previousData?.DrivingLicenceNumber !== ""
                  }
                />

                <TextField
                  label="Drivers Licence Expiry"
                  variant="outlined"
                  fullWidth
                  type="date"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...register("drivingLicenceExpiryDate")}
                  error={!!errors.drivingLicenceExpiryDate}
                  helperText={errors.drivingLicenceExpiryDate?.message}
                  disabled={
                    disableEdit &&
                    previousData?.DrivingLicenceExpiryDate &&
                    previousData?.DrivingLicenceExpiryDate !== undefined &&
                    previousData?.DrivingLicenceExpiryDate !== ""
                  }
                />

                <Grid item xs={12}>
                  <Box sx={{ mt: 2 }}>
                    <PlacesAutoComplete
                      onAddressChange={handleAddressChange}
                      ref={autoCompleteRef}
                      incidentAddress={incidentAddress}
                      label="Home Address"
                      disabled={
                        disableEdit &&
                        previousData?.Address &&
                        previousData?.Address !== null &&
                        previousData?.Address !== ""
                      }
                      page="otherDriverDetails"
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={{ mt: 2, mb: 2 }}>
                    <Controller
                      control={control}
                      name="cellTelephoneNumber"
                      className={classes.flexContainer}
                      render={({ field: { value, onChange } }) => (
                        <VirPhoneInput
                          phoneNumber={value}
                          onChange={(phone) => handlePhoneChange(phone, "cellTelephoneNumber")}
                          disabled={
                            disableEdit &&
                            previousData?.CellTelephoneNumber !== "" &&
                            previousData?.CellTelephoneNumber !== undefined
                          }
                        />
                      )}
                    />
                  </Box>
                </Grid>

                <TextField
                  label="Email Address"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  {...register("email")}
                  disabled={
                    disableEdit && previousData?.Email !== "" && previousData?.Email != undefined
                  }
                />

                <FormControl fullWidth variant="outlined" margin="normal">
                  <InputLabel>Select the relationship</InputLabel>
                  <Controller
                    name="relationship"
                    control={control}
                    defaultValue={[]}
                    rules={{
                      validate: (value) => value.length !== 1 || "Please select one relationship",
                    }}
                    render={({ field: { onChange, value } }) => (
                      <>
                        <Select
                          labelId="dropdown-label"
                          value={value}
                          onChange={onChange}
                          label="Select relationship"
                          disabled={
                            disableEdit &&
                            previousData?.Relationship !== "" &&
                            previousData?.Relationship !== undefined
                          }
                        >
                          <MenuItem value="Spouse / De Facto Partner">
                            Spouse / De Facto Partner
                          </MenuItem>
                          <MenuItem value="Parent / Parent in Law / Step Parent">
                            Parent / Parent in Law / Step Parent
                          </MenuItem>
                          <MenuItem value="Grandparents / Grandparents in Law / Step Grandparents">
                            Grandparents / Grandparents in Law / Step Grandparents
                          </MenuItem>
                          <MenuItem value="Son / Step Son / Son in Law">
                            Son / Step Son / Son in Law
                          </MenuItem>
                          <MenuItem value="Daughter / Step Daughter / Daughter in Law">
                            Daughter / Step Daughter / Daughter in Law
                          </MenuItem>
                          <MenuItem value="Brother / Half Brother / Step Brother / Brother in Law">
                            Brother / Half Brother / Step Brother / Brother in Law
                          </MenuItem>
                          <MenuItem value="Sister / Half Sister / Step Sister / Sister in Law">
                            Sister / Half Sister / Step Sister / Sister in Law
                          </MenuItem>
                          <MenuItem value="Friend">Friend</MenuItem>
                          <MenuItem value="Other">Other</MenuItem>
                        </Select>
                        {value === "Other" && (
                          <TextField
                            label="Other relationship"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            {...register("otherRelationship")}
                            disabled={
                              disableEdit &&
                              previousData?.OtherRelationship !== "" &&
                              previousData?.OtherRelationship != undefined
                            }
                          />
                        )}
                      </>
                    )}
                  />
                  {errors.relationship && (
                    <FormHelperText>{errors.relationship.message}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          </>
          <Box sx={{ my: 3 }}>
            <div>
              <RoundedButton
                variant="contained"
                type="submit"
                fullWidth
                disabled={loading}
                sx={{ mt: 2, width: "80%", margin: "2" }}
              >
                {loading ? <CircularProgress /> : "Continue"}
              </RoundedButton>
            </div>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default DigitalVIROtherDriverDetails;
